import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useTab } from '@/common/entityFramework/entityTabs/TabContext';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCallback, useEffect, useRef, useState } from 'react';
import { AbvOverUnderScenReasonablenessToggle } from './AbvOverUnderScenReasonablenessToggle';

export const AbvOverUnderScenList = () => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();
  const entityListRef = useRef();

  const { openDialog } = useDialog();

  const { navState, assign } = useNavState();
  const { tabId } = useTab();
  const abvOverUnderScenListStateId = tabId ? tabId + 'AbvOverUnderScenListState' : 'AbvOverUnderScenListState';
  const abvOverUnderScenListState = navState[abvOverUnderScenListStateId] ?? {};

  const [reasonablenessFlag, setReasonablenessFlag] = useState(abvOverUnderScenListState.reasonablenessFlag ?? false);

  const entity = 'OVER_UNDER_SCEN';

  // ---- NavState ----

  const saveNavState = () => {
    const newAbvOverUnderScenListState = {
      reasonablenessFlag,
    };

    assign(abvOverUnderScenListStateId, newAbvOverUnderScenListState);
  };

  useEffect(() => {
    saveNavState();
  }, [reasonablenessFlag]);

  // ---- Data ----

  const clientSideRowData = useCallback(
    (setDataSource) => {
      const reqParam = {
        ...navState.reqParam,
        entity,
        reasonablenessFlag,
      };

      rsrc.data(module, 'OVER_UNDER_SCEN_REASONABLENESS_DATA_PLUGIN', reqParam, entity).then((res) => {
        setDataSource(res);
      });
    },
    [reasonablenessFlag],
  );

  // ---- Actions ----

  const augButtons = useCallback(
    (buttons) => {
      buttons.push(
        <AbvOverUnderScenReasonablenessToggle
          key="reasonablenessToggle"
          reasonablenessFlag={reasonablenessFlag}
          setReasonablenessFlag={setReasonablenessFlag}
        />,
      );
    },
    [reasonablenessFlag],
  );

  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);

    contextMenus.forEach((menu) => {
      if (menu.name === 'Delete') {
        menu.action = () => openDeleteActionDialog(params);
        return;
      }
    });

    return contextMenus;
  };

  const openDeleteActionDialog = (params) => {
    openDialog(ActionDialog, {
      data: {
        title: 'Delete Scenario',
        pluginCode: 'OVER_UNDER_SCEN_DELETE_ACTION_PLUGIN',
        entity,
        entityId: params.node.data.id,
      },
    });
  };

  return (
    <EntityList
      ref={entityListRef}
      entity={entity}
      clientSideRowData={clientSideRowData}
      augButtons={augButtons}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
